import { useCallback } from 'react';
import { useHistory } from 'react-router-dom';

export const useViagensNavegacao = () => {
  const history = useHistory();

  // Navegar para detalhes da viagem
  const handleRowClick = useCallback((row) => {
    console.log('🖱️ Clicou na linha:', row);
    console.log('🖱️ ID da linha:', row.id);
    console.log('🖱️ Navegando para:', `/pages/viagens/detalhes/${row.id}`);
    history.push(`/pages/viagens/detalhes/${row.id}`);
  }, [history]);

  // Navegar para criar nova viagem
  const handleAdicionar = useCallback(() => {
    console.log('➕ Botão adicionar clicado');
    history.push('/pages/viagens/criar');
  }, [history]);

  // Navegar para editar viagem
  const handleEditar = useCallback((id) => {
    console.log('✏️ Editando viagem:', id);
    history.push(`/pages/viagens/editar/${id}`);
  }, [history]);

  return {
    // Handlers de navegação
    handleRowClick,
    handleAdicionar,
    handleEditar
  };
};
